import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useContent } from '../../context/ContentContext';
import {
  createEmptyDetail,
  createEmptyService,
  DEFAULT_SERVICE_TIMES,
  resolveServiceTimes,
} from '../../data/serviceTimes';
import RichTextField from './RichTextField';
import './editable.css';

export default function EditableServiceTimes() {
  const { isEditing } = useAuth();
  const { getContent, setContentValue } = useContent();
  const services = resolveServiceTimes(getContent);

  const saveServices = (nextServices) => {
    setContentValue('home.services.items', nextServices);
  };

  const updateService = (serviceId, updater) => {
    saveServices(services.map((service) => (service.id === serviceId ? updater(service) : service)));
  };

  const removeService = (serviceId) => {
    if (!window.confirm('Remove this service day?')) return;
    saveServices(services.filter((service) => service.id !== serviceId));
  };

  const addService = () => {
    saveServices([...services, createEmptyService()]);
  };

  const addDetail = (serviceId) => {
    updateService(serviceId, (service) => ({
      ...service,
      details: [...service.details, createEmptyDetail()],
    }));
  };

  return (
    <div className="service-times" data-content-key="home.services.items">
      <div className="service-row">
        {services.map((service, index) => (
          <div
            key={service.id}
            className={`service-item ${isEditing ? 'service-item--editing' : ''}`}
            data-aos="fade-up"
            data-aos-delay={120 + index * 100}
            data-aos-duration="600"
            data-aos-offset="60"
          >
            <RichTextField
              isEditing={isEditing}
              tag="h4"
              className="day editable-service-field"
              value={service.day}
              onChange={(day) => updateService(service.id, (current) => ({ ...current, day }))}
            />

            {service.details.map((detail) => (
              <p key={detail.id} className="time-details">
                {isEditing ? (
                  <>
                    <RichTextField
                      isEditing
                      className="editable-service-field"
                      value={detail.description}
                      onChange={(description) =>
                        updateService(service.id, (current) => ({
                          ...current,
                          details: current.details.map((item) =>
                            item.id === detail.id ? { ...item, description } : item
                          ),
                        }))
                      }
                    />
                    :{' '}
                    <span className="time">
                      <RichTextField
                        isEditing
                        className="editable-service-field"
                        value={detail.time}
                        onChange={(time) =>
                          updateService(service.id, (current) => ({
                            ...current,
                            details: current.details.map((item) =>
                              item.id === detail.id ? { ...item, time } : item
                            ),
                          }))
                        }
                      />
                    </span>
                    <br />
                    <span className="location">
                      <RichTextField
                        isEditing
                        className="editable-service-field"
                        value={detail.location || ''}
                        onChange={(location) =>
                          updateService(service.id, (current) => ({
                            ...current,
                            details: current.details.map((item) =>
                              item.id === detail.id ? { ...item, location } : item
                            ),
                          }))
                        }
                      />
                    </span>
                  </>
                ) : (
                  <>
                    <RichTextField isEditing={false} value={detail.description} />:
                    {' '}
                    <span className="time">
                      <RichTextField isEditing={false} value={detail.time} />
                    </span>
                    <br />
                    {detail.location ? (
                      <span className="location">
                        <RichTextField isEditing={false} value={detail.location} />
                      </span>
                    ) : null}
                  </>
                )}
              </p>
            ))}

            {isEditing && (
              <div className="editable-list-actions">
                <button type="button" className="editable-list-btn" onClick={() => addDetail(service.id)}>
                  + Add time slot
                </button>
                <button type="button" className="editable-list-btn editable-list-btn--danger" onClick={() => removeService(service.id)}>
                  Remove day
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {isEditing && (
        <div className="editable-list-footer">
          <button type="button" className="editable-list-btn editable-list-btn--primary" onClick={addService}>
            + Add service day
          </button>
        </div>
      )}
    </div>
  );
}

export { DEFAULT_SERVICE_TIMES };
